<template>
  <div>
    <b-modal :id="theme" visible no-close-on-backdrop no-close-on-esc hide-header-close hide-footer
      header-class="p-0 border-0" body-class="px-4 pt-5 pb-0" size="xl" title="リハビリテーション">
      <Loader :loading="loading" style="min-height: 400px">
        <div v-if="rehabVideoSuggestion">
          <div>
            <h2 class="text-center mb-3 font-weight-semibold">AIリハビリメニュー</h2>
          </div>
          <div>
            <div class="text-center">
                AIが提案したメニューの中から表示する動画を最大3つ選択できます
            </div>
          </div>
          <div class="pt-4" style="max-height: 490px; overflow-y: auto; overflow-x: hidden">
            <div class="row" v-if="rehabVideoSuggestion?.videos">
              <div v-for="suggestVideo in rehabVideoSuggestion.videos" :key="suggestVideo.id" class="col-4">
                <div class="mt-3">
                  <div class="rounded-3 border-3 p-3" style="border-color: #666">
                    <div class="row">
                      <div class="col-12 col-xl-6 text-center">
                        <a @click="openVideoPopup(suggestVideo.path)">
                          <img class="w-100" :src="suggestVideo.thumbnail" onerror="this.src='/img/noinage.jpg';"
                            :alt="suggestVideo.name">
                        </a>
                      </div>
                      <div class="col-12 col-xl-6">
                        <div class="mt-2 mt-xl-0">
                          <h6 class="font-weight-semibold video-title-241101">{{ suggestVideo.name }}</h6>
                          <div>{{ suggestVideo.duration ? `${calcMinutes(suggestVideo.duration)}分` : '' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-6">
                <h6>リハビリメニュー名*</h6>
                <div class="form-control overflow-hidden" style="text-overflow: ellipsis;">{{ rehabVideoSuggestion?.title }}</div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-6 12 col-xl-4">
                    <h6>部位</h6>
                    <div class="font-weight-semibold fs-5 mt-3">{{ rehabVideoSuggestion?.type_name }}</div>
                  </div>
                  <div class="col-6 12 col-xl-4">
                    <h6>合計時間</h6>
                    <div class="font-weight-semibold fs-5 mt-3">{{ calcMinutes(rehabVideoSuggestion?.duration) }}分</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer mt-0 border-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-2 offset-6">
                  <button class="btn btn-lyg w-100" type="button" @click="editRehabVideoSuggestion">編集</button>
                </div>
                <div class="col-2">
                  <button class="btn btn-danger w-100" type="button" @click="deleteRehabVideoSuggestion">削除</button>
                </div>
                <div class="col-2">
                  <button class="btn btn-light w-100" type="button" @click="closeModal">閉じる</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loader>
      <VideoPopup :videoURL="videoUrl" @closeModal="showVideoFlag = false" :isShow="showVideoFlag" />
    </b-modal>
  </div>
</template>

<script>
import api from "@/api";
import Loader from "@/components/widgets/loader.vue";
import VideoPopup from "@/components/widgets/video-popup.vue";
import moment from "moment";
import startVideo from "@/pages/video/start-video.vue";
import {REHAB_VIDEO_SUGGESTION_TYPE} from "@/constant";
export default {
  components: {startVideo, Loader, VideoPopup},
  props: ['rehabVideoSuggestionId', 'reloading'],
  data() {
    return {
      loading: true,
      rehabVideoSuggestion: null,
      showVideoFlag: false,
      videoUrl: null,
    };
  },
  async created() {
    await this.RehabVideoSuggestion();

    this.loading = false;
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    async RehabVideoSuggestion() {
      const res = await api.getDetailRehabVideoSuggestion(this.rehabVideoSuggestionId);

      if (res.status === 200) {
        this.rehabVideoSuggestion = res.data;
      }
    },
    calcMinutes(timeString) {
      const time = moment(timeString, "HH:mm:ss");

      return Math.round(time.hours() * 60 + time.minutes() + (time.seconds() / 60));
    },
    closeModal() {
      this.$emit("close");
    },
    editRehabVideoSuggestion() {
      this.$emit("editRehab");
    },
    deleteRehabVideoSuggestion() {
      this.$emit("deleteRehab");
    },
    openVideoPopup(videoUrl) {
      this.videoUrl = videoUrl;
      this.showVideoFlag = true;
    }
  },
  watch: {
    reloading(newVal) {
      if (newVal) {
        this.loading = true;
        this.RehabVideoSuggestion();
        this.$emit('updated');
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
::v-deep .modal-header {
  display: none;
}
.video-title-241101 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 3.6em;
  text-align: justify;
}
</style>
